<template>
  <tr class="to-deponents">
    <td class="date-container">
      <span class="link" @click="handleloadFile" v-if="!data.file">
        Загрузить документ
      </span>
      <span v-else>
        <span class="link">{{data.file}}</span>
        <span class="delete-document" @click="deleteDeponentsDocumentFile(data.id)">X</span>
      </span>
      <input type="file" id='photo' @change='loadFile' hidden ref="loadFile"/>
    </td>
    <td class="date-container">
      <el-date-picker
        type="date"
        :editable="false"
        v-model="publishDate"
        @change="dateChanged"
        >
      </el-date-picker>
    </td>
    <td class="date-container">
      <el-date-picker
        type="date"
        :editable="false"
        v-model="eventDate"
        @change="dateChanged"
        >
      </el-date-picker>
    </td>
    <td class="title-data">
      <b-input v-model="data.eventTitle" @change='handleUpdate' />
    </td>
    <td class="emitents-data">
      <el-select v-model="selectedData" placeholder="" filterable @change="dataSelected">
        <el-option v-for="item in emitentsData" :key="item.id" :label='item.value' :value='item.id'>
          <span style="float: left">{{ item.value }}</span>
        </el-option>
      </el-select>
    </td>
    <td class="date-container">
      <el-date-picker
        type="date"
        :editable="false"
        v-model="registryClippingDate"
        @change="dateChanged"
        >
      </el-date-picker>
    </td>
    <td class="date-container">
      <el-date-picker
        type="date"
        :editable="false"
        v-model="fixationDate"
        @change="dateChanged"
        >
      </el-date-picker>
    </td>
    <td class="delete-cell">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteDeponentsData(data.id)"/>
    </td>
  </tr>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { VueEditor as Editor } from 'vue2-editor'

export default {
  name: 'ToDeponentsItem',
  data () {
    return {
      updateTimer: null,
      publishDate: null,
      registryClippingDate: null,
      fixationDate: null,
      eventDate: null,
      selectedData: null
    }
  },
  created () {
    this.eventDate = this.data.eventDate
    this.registryClippingDate = this.data.registryClippingDate
    this.publishDate = this.data.publishDate
    this.selectedData = this.data.data
    this.fixationDate = this.data.fixationDate
  },
  props: {
    data: {
      required: true
    }
  },
  watch: {
  },
  computed: {
    ...mapState(['emitentsData'])
  },
  methods: {
    ...mapActions(['deleteDeponentsData', 'updateDeponentsData', 'loadDeponentsDocumentFile', 'deleteDeponentsDocumentFile']),
    handleUpdate () {
      this.updateDeponentsData(this.data)
    },
    loadFile (e) {
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      this.loadDeponentsDocumentFile({ formData, id: this.data.id })
    },
    handleloadFile () {
      this.$refs.loadFile.click()
    },
    dataSelected () {
      this.data.data = this.selectedData
      this.handleUpdate()
    },
    dateChanged () {
      this.data.eventDate = this.eventDate
      this.data.publishDate = this.publishDate
      this.data.registryClippingDate = this.registryClippingDate
      this.data.fixationDate = this.fixationDate
      this.handleUpdate()
    }
  },
  components: { Editor }
}
</script>
<style scoped>
td {
  padding: 10px 5px;
}
.delete-cell {
  position: relative;
  width: 30px;
  padding: 0;
}
.delete-icon {
  top: 12px;
  right: 0;
}
.emitents-data {
  min-width: 180px;
  max-width: 180px;
}
.title-data {
  min-width: 140px;
  max-width: 160px;
}
.el-date-editor {
  width: 145px;
}
.date-container {
  width: 150px;
}
td:first-child {
  width: 100px;
}
.delete-document {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ToDeponentsItem.vue?21551163